// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__39FXD","content":"ManualTimeModal_content__3mA7J"};